import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { SearchHistoryPanelAppState } from './types';

const initialState: SearchHistoryPanelAppState = {
  searchHistoryIds: [],
};

export const searchHistoryPanelSlice = createSlice({
  name: 'search_history',
  initialState,
  reducers: {
    setSearchHistoryIds: (state, action: PayloadAction<string[]>) => {
      state.searchHistoryIds = action.payload;
    },
  },
});

export const { setSearchHistoryIds } = searchHistoryPanelSlice.actions;

export const searchHistoryPanelReducer = searchHistoryPanelSlice.reducer;
